// Those regexes allow to check for starting or trailing <p><br></p> and <br>
// tags in WYSIWTG generated HTML that generate useless whitespace
//

const EMPTY_HTML_PATTERN = " *(<p> *(<br */?>)</p>|<br *>)* *";

const EMPTY_HTML_RX = new RegExp(EMPTY_HTML_PATTERN, "g");
const EMPTY_HTML_START_RX = new RegExp(`^${EMPTY_HTML_PATTERN}`, "g");
const EMPTY_HTML_END_RX = new RegExp(`${EMPTY_HTML_PATTERN}$`, "g");

export function trimHtml(string) {
  if (!string || !string.length) return string;

  return string.replace(EMPTY_HTML_START_RX, "").replace(EMPTY_HTML_END_RX, "");
}

export function cleanHtml(string) {
  if (!string || !string.length) return string;

  const trimmedString = trimHtml(string);

  return (
    trimmedString
      // Remove draft-js generated whitespace inside <img> tags
      .replace(/>(&nbsp;)*<\/img>/g, "/>")
      // Remove draft-js generated whitespace at the end of <figure> tags
      .replace(/\/>(&nbsp;)*<\/figure>/, "/></figure>")
  );
}

export function hasHtmlContent(string) {
  if (!string || !string.length) return false;
  // Force returning a boolean to be used in JSX expression conditions.
  return string.replace(EMPTY_HTML_RX, "").length ? true : false;
}

export const matchSearchTerms = (string, searchTerms) => {
  return string.toLowerCase().includes(searchTerms.toLowerCase());
};

export const stripHTML = html => {
  const element = document.createElement("div");
  element.innerHTML = html;

  return element.textContent;
};
